import React from "react";
import { Progress } from "antd";

const BranchCard = props => {
  const { list, bookedPickupDate, bookedDeliveryDate, renderProgress } = props;
  const bottomContent = (bottom, type) => {
    switch (type) {
      case undefined:
        return <label>{bottom}</label>;
      case "email":
        return (
          <label>
            <a
              href={`mailto:${bottom}?subject=Found%20your%20equipment%20on%20equipmentfinder.rainforrent.com%20and%20I%20want%20to%20talk%20about%20it`}
            >
              {bottom}
            </a>
          </label>
        );
      case "phone":
        return (
          <label>
            {bottom ? (
              <a href={`tel:+1 ${bottom}`}>{bottom}</a>
            ) : (
              "No contact information is available please contact support."
            )}
          </label>
        );
      default:
        return <label>{bottom}</label>;
    }
  };

  const content = (top, bottom, dark = false, type) => {
    if ((!bookedPickupDate || !bookedDeliveryDate) && type === "progress") {
      return (
        <div key={top} className="branchCard">
          <label>{dark ? <strong>{top}</strong> : top}</label>
          {bottomContent(bottom, type)}
        </div>
      );
    }

    const start = new Date(bookedDeliveryDate).getTime() / 1000;

    const end = new Date(bookedPickupDate).getTime() / 1000;

    const today = new Date().getTime() / 1000;

    const p = Math.round(((today - start) / (end - start)) * 100);
    return (
      <div className="branchCard" key={top}>
        {type === "progress" ? (
          <>
            <div>
              <strong>{top}</strong>
            </div>
            <Progress percent={p} showInfo={false} />
            <div className="PercentDate">
              <div>{`${bookedDeliveryDate.substring(
                5,
                7
              )}/${bookedDeliveryDate.substring(
                8,
                10
              )}/${bookedDeliveryDate.substring(0, 4)}`}</div>
              <div>{`${bookedPickupDate.substring(
                5,
                7
              )}/${bookedPickupDate.substring(
                8,
                10
              )}/${bookedPickupDate.substring(0, 4)}`}</div>
            </div>
          </>
        ) : (
          <>
            <label>{dark ? <strong>{top}</strong> : top}</label>
            {bottomContent(bottom, type)}
          </>
        )}
      </div>
    );
  };

  return (
    <div className={"Card"}>
      {list.map((elem, index) =>
        content(elem.top, elem.bottom, true, elem.type)
      )}
    </div>
  );
};

export default BranchCard;
